import { fleetManagementApi } from "../api";

export const getAllBookings = async () => {
  const response = await fleetManagementApi.get("/bookings");
  return response;
}

export const confirmBooking = async ({ bookingId, payload }) => {
  const response = await fleetManagementApi.put(`/bookings/${bookingId}/confirm`, payload);
  return response;
}